import React, { useMemo, useState } from 'react'
import { UpdatedRequestTable } from '../../../../../../components/table/RequestTable';
import { convertTo12Hour } from '../../../../../../utils/dateTimeFormatter';
import { useNavigate } from 'react-router-dom';
import { clearFlaggedQuestion } from '../../../../../../features/candidate-exam/candidate-exam-slice';
import { useDispatch } from 'react-redux';
import UnlockAssessmentModal from './unlockAssessmentModal';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

const VirtualExams = ({
          exams, isLoading, currentPage, setCurrentPage, perPage, setPerPage,
          refetch,
        }) => {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [isLocked, setIsLocked] = useState(false)
    const { t } = useTranslation()

    const handleActionClick = (row) => {
      if(!row?.number_of_attempts_allowed || (
        row?.number_of_attempts >= row?.number_of_attempts_allowed
      )) return toast.error('You have reach the maximum attempt limit')
      if(row?.exam_is_locked){
        sessionStorage.setItem('active-exam',  JSON.stringify(row))
        setIsLocked(true)
      }
      else {
        dispatch(clearFlaggedQuestion());
        window.sessionStorage.setItem("active-assessment-id", row?.exam_id);
        window.sessionStorage.setItem("active-assessment-user-id", row?.user_exam_id);
        window.sessionStorage.setItem("active-assessment", JSON.stringify(row));
        window.sessionStorage.setItem("time_left", row?.time_left);
        window.sessionStorage.setItem("duration", row?.exam_duration);
        window.sessionStorage.setItem("ql", row?.number_of_questions);
        window.sessionStorage.setItem("starting-index", row?.number_of_questions_answered);
        window.sessionStorage.setItem("examType", row?.exam_question_type);
        navigate("/candidate/assessments/instructions");
      }
     }

    let columns = useMemo(
        () => [
          {
            title: t('id'),
            selector: null,
            key: "id",
            render: ({ index }) =>
              index +
              1 +
              ((exams?.meta?.current_page || 1) - 1) *
                (exams?.meta?.per_page || perPage),
          },
          {
            title: t('exam-name'),
            selector: "exam_name",
            key: "exam_name",
            render: ({ item, row }) => {
              return (
                <button
                  className="text-baseFont underline text-primary"
                  onClick={ () => handleActionClick(row) }
                >
                  {item}
                </button>
              );
            },
          },
          {
            title: t('duration'),
            selector: "exam_duration",
            key: "exam_duration",
            render: ({ item }) => {
                return (
                  <button className="text-baseFont">
                    {item} mins 
                  </button>
                );
              },
          }, 
          {
            title: t('questions'),
            selector: "number_of_questions",
            key: "number_of_questions",
            render: ({ item, row }) => {
                return (
                  <button
                    className="text-baseFont pl-3"
                  >
                    { row?.number_of_questions_answered ? 
                       <span className='flex'>
                           <del className='text-red-500'>{item}</del>
                           <span className='ml-2'>
                             { parseInt(item)  - row?.number_of_questions_answered}
                           </span>
                       </span>
                    : item } 
                  </button>
                );
              },
          },
          {
            title: t('start-date'),
            selector: "start_date",
            key: "start_date",
            render: ({item}) => {
              return <span>{`${ new Date(item).toLocaleDateString('en-ng')}`}</span>
            }
          },
          {
            title: t('end-date'),
            selector: "end_date",
            key: "end_date",
            render: ({item}) => {
              return <span>{`${ new Date(item).toLocaleDateString('en-ng')}`}</span>
            }
          },
          {
            title: t('start-time'),
            selector: "start_time",
            key: "start_time",
            render: ({item}) => {
              return <span>{`${convertTo12Hour(item)}`}</span>
            }
          },
          {
            title: t('end-time'),
            selector: "end_time",
            key: "end_time",
            render: ({item}) => {
              return <span>{`${convertTo12Hour(item)}`}</span>
            }
          },
          {
            title: t('action'),
            selector: null,
            key: null,
            render: ({item, row}) => {
              return <button 
                       className='bg-primary rounded-full text-white py-2 px-5 text-sm'
                       onClick={() => handleActionClick(row)}
                      >
                       { row?.exam_is_locked ? t('unlock-exam') : 
                        row?.number_of_questions_answered ? t('continue') : t('start-exam')
                       }
                    </button>
            }
          },
     ], [exams?.meta?.current_page, exams?.meta?.per_page, perPage])

  return (
    <div className='p-3 rounded-lg bg-white'>
        <div className='max-[500px]:hidden'>
            <UpdatedRequestTable
                columns={columns}
                data={exams?.upcoming_exams}
                isLoading={isLoading}
          />
        </div>
        <div className='md:hidden grid grid-cols-1 gap-5'>
           {
              exams?.upcoming_exams?.length ? 
               exams?.upcoming_exams?.map( exam => {
                 return (
                  <ul key={exam?.id} className="border border-gray-200 rounded-lg mb-8 p-0">
                  <li className="flex justify-between py-3 px-4">
                     <span className="text-lg">{t('exam-name')}:&nbsp;</span>
                     <span className="text-lg">
                        {exam?.exam_name}
                     </span>
                  </li>
                  <li className="flex justify-between bg-gray-100 py-4 px-4">
                     <span className="text-lg">{t('duration')}:&nbsp;</span>
                     <span className="text-lg">
                     {exam?.exam_duration}
                     </span>
                  </li>
                  <li className="flex justify-between py-4 px-4">
                     <span className="text-lg">{t('questions')}:&nbsp;</span>
                     <span className={`text-lg`}>
                        { exam?.number_of_questions_answered ? 
                          <span className='flex'>
                              <del className='text-red-500'>{exam?.number_of_questions}</del>
                              <span className='ml-2'>
                                { parseInt(exam?.number_of_questions)  - exam?.number_of_questions_answered}
                              </span>
                          </span>
                        : exam?.number_of_questions } 
                     </span>
                  </li>
                  <li className="flex bg-gray-100 justify-between py-4 px-4">
                    <div className='flex items-center'>
                      <span className="text-lg">{t('start-date')}:&nbsp;</span>
                      <span className={`text-lg ml-4`}>
                          {`${ new Date(exam?.start_date).toLocaleDateString('en-ng')}`}
                      </span>
                      </div>
                      <div className='flex items-center'>
                      <span className="text-lg">{t('end-date')}:&nbsp;</span>
                      <span className={`text-lg ml-4`}>
                          {`${ new Date(exam?.end_date).toLocaleDateString('en-ng')}`}
                      </span>
                      </div>
                  </li>
                  <li className="flex justify-between py-4 px-4">
                    <div className='flex items-center'>
                      <span className="text-lg">{t('start-time')}:&nbsp;</span>
                      <span className={`text-lg ml-4`}>
                       {`${convertTo12Hour(exam?.start_time)}`}
                      </span>
                      </div>
                      <div className='flex items-center'>
                      <span className="text-lg">{t('end-time')}:&nbsp;</span>
                      <span className={`text-lg ml-4`}>
                        {`${convertTo12Hour(exam?.end_time)}`}
                      </span>
                      </div>
                  </li>
                  <li className="flex justify-between bg-gray-100 py-4 px-4">
                     <span className="text-lg">{t('action')}:&nbsp;</span>
                     <button 
                       className='bg-primary rounded-full text-white py-2 px-5 text-sm'
                       onClick={ () => handleActionClick(exam)}
                      >
                        { 
                          exam?.exam_is_locked ? t('unlock-exam') : 
                          exam?.number_of_questions_answered ? t('continue') :  t('start-exam')
                        }
                    </button>
                  </li>
               </ul>
                 )
               } )
              : null
           }
        </div>
       {
           isLocked ?
             <UnlockAssessmentModal 
                refetch={refetch} closeModal={setIsLocked} 
             />
           : null
         }
    </div>
  )
}

export default VirtualExams